import React from 'react';
import { useLocale } from '../i18n/LocaleProvider';
import config from '../config';
import MailMenu from './MailMenu';

// Group-wide open / spontaneous application CTA.
export default function SpontaneousApplication() {
  const { t } = useLocale();

  return (
    <section className="rounded-2xl border border-sand bg-gradient-to-br from-cream to-beige p-8 sm:flex sm:items-center sm:justify-between sm:gap-8">
      <div className="max-w-xl">
        <p className="eyebrow">{t.spontaneousEyebrow}</p>
        <h2 className="mt-2 font-display text-2xl text-greenDeep">{t.spontaneousTitle}</h2>
        <p className="mt-2 text-ink/75">{t.spontaneousBody}</p>
      </div>
      <div className="mt-5 sm:mt-0">
        <MailMenu
          email={config.spontaneousEmail}
          subject={t.spontaneousSubject}
          body={t.spontaneousMailBody}
          label={t.spontaneousCta}
          className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-greenDeep px-6 py-3 font-num text-xs font-medium uppercase tracking-wider text-cream shadow-card transition-colors hover:bg-gold hover:text-greenDeep"
        />
      </div>
    </section>
  );
}
